<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="openModal"
      scrollable
      size="lg"
      title="Pendencias"
    >
      <div v-if="pendencie != null && pendencie.checklistValue != null">
        <h2>{{ $t("checklist.form.PendencyDetails") }}</h2>

        <b-form-group
          :label="$t('checklist.form.NameForm')"
          label-for="input-formName"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            id="input-formName"
            v-model="pendencie.formName"
            readonly
          />
        </b-form-group>
        <b-form-group
          :label="$t('checklist.pendencies.pendencyCreatedAt')"
          label-for="input-datePendencie"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            id="input-datePendencie"
            v-model="formatedDatePendecie"
            readonly
          />
        </b-form-group>
        <b-form-group
          :label="$t('checklist.pendencies.pendencyDescription')"
          label-for="input-Description"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            id="input-Description"
            v-model="pendencie.description"
            readonly
          />
        </b-form-group>

        <b-form-group
          :label="$t('checklist.pendencies.pendencyFieldName')"
          label-for="input-filledField"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            id="input-filledField"
            v-model="pendencie.checklistValue.fieldName"
            readonly
          />
        </b-form-group>

        <pendency-details-checklist-value
          :checklist-value="pendencie.checklistValue"
          :label="$t('checklist.pendencies.pendencyFieldValue')"
        >
        </pendency-details-checklist-value>

        <div v-if="isExpired">
          <b-form-group
            :label="$t('checklist.pendencies.pendencyExpirationDate')"
            label-for="DateExpiration"
            label-cols-sm="5"
            label-cols-md="5"
            label-cols-lg="5"
          >
            <b-form-input
              id="DateExpiration"
              v-model="formatedDateExpiration"
              readonly
            />
          </b-form-group>
        </div>

        <div v-if="isExpired">
          <b-form-group
            :label="$t('checklist.pendencies.pendencyExpirationDate')"
            label-for="DateExpiration"
            label-cols-sm="5"
            label-cols-md="5"
            label-cols-lg="5"
          >
            <b-form-input
              id="DateExpiration"
              v-model="formatedDateExpiration"
              readonly
            />
          </b-form-group>
        </div>

        <div v-if="isInApproval" class="mt-3 mb-3">
          <h4>{{ $t("checklist.pendencies.approval") }}</h4>
          <pendency-approval
            :pendency-id="pendencie.id"
            @after-approval="approvalEnd"
            @cancel-approval="approvalEnd"
          >
          </pendency-approval>
        </div>

        <div v-if="isInDisapproval" class="mt-3 mb-3">
          <h4>{{ $t("checklist.pendencies.disapproval") }}</h4>
          <pendency-disapproval
            :pendency-id="pendencie.id"
            @after-disapproval="disapprovalEnd"
            @cancel-disapproval="disapprovalEnd"
          >
          </pendency-disapproval>
        </div>

        <div v-if="isApproved" class="mt-3">
          <h4>{{ $t("checklist.pendencies.approvalData") }}</h4>
          <pendency-approved-data :pendency="pendencie">
          </pendency-approved-data>
        </div>

        <div v-if="isDisapproved" class="mt-3">
          <h4>{{ $t("checklist.pendencies.disapprovalData") }}</h4>
          <pendency-disapproved-data :pendency="pendencie">
          </pendency-disapproved-data>
        </div>

        <div>
          <b-button
            v-if="canApprove"
            size="sm"
            class="mr-2"
            variant="green"
            @click="approvalBegin"
          >
            {{ $t("checklist.form.ApprovalPendencies") }}
          </b-button>
          <b-button
            v-if="canApprove"
            size="sm"
            class="mr-2"
            variant="danger"
            @click="disapprovalBegin"
          >
            {{ $t("checklist.form.DisapprovalPendency") }}
          </b-button>
        </div>

        <b-card v-if="showFilledDetails" class="mt-3">
          <filled-details
            :id="pendencie.checklistId.toString()"
          ></filled-details>
        </b-card>

        <div class="mt-3">
          <h4>{{ $t("checklist.pendencies.comments") }}</h4>
          <div v-if="canMakeComments">
            <pendency-comment-new
              :pendency-id="pendencie.id"
              @after-add="loadData"
            >
            </pendency-comment-new>
          </div>
          <div v-for="comment in pendencie.comments" :key="comment.id">
            <pendency-comment class="mt-4" :comment="comment">
            </pendency-comment>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="w-100">
          <b-button class="float-right" variant="danger" @click="cancel()">
            {{ $t("geral.close") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import FilledDetails from "@/pagesRms/checklist/checklist/ChecklistFilledDatails.vue";
import PendencyApproval from "@/components_rms/checklist/pendency/PendencyApproval.vue";
import PendencyApprovedData from "@/components_rms/checklist/pendency/PendencyApprovedData.vue";
import PendencyComment from "@/components_rms/checklist/pendency/PendencyComment.vue";
import PendencyCommentNew from "@/components_rms/checklist/pendency/PendencyCommentNew.vue";
import PendencyDetailsChecklistValue from "@/components_rms/checklist/pendency/PendencyDetailsChecklistValue.vue";
import PendencyDisapprovedData from "@/components_rms/checklist/pendency/PendencyDisapprovedData.vue";
import PendencyDisapproval from "@/components_rms/checklist/pendency/PendencyDisapproval.vue";

export default {
  name: "PendencyModal",
  data() {
    return {
      checklistValueId: 0,
      ApprovalDescription: "",
      isInApproval: false,
      isInDisapproval: false,
      pendencie: {},
      showFilledDetails: false,
      fieldName: "",
    };
  },
  components: {
    PendencyDetailsChecklistValue,
    FilledDetails,
    PendencyApproval,
    PendencyApprovedData,
    PendencyComment,
    PendencyCommentNew,
    PendencyDetailsChecklistValue,
    PendencyDisapproval,
    PendencyDisapprovedData,
  },
  computed: {
    canApprove() {
      if (!this.isOpened) return false;
      if (this.isInApproval) return false;
      if (this.isInDisapproval) return false;
      if (!this.pendencie) return false;
      if (!this.pendencie.pendencyUserPermissions) return false;
      if (!this.pendencie.pendencyUserPermissions) return false;
      return this.pendencie.pendencyUserPermissions.isApprover;
    },
    canMakeComments() {
      if (!this.isOpened) return false;
      if (this.isInApproval) return false;
      if (this.isInDisapproval) return false;
      if (!this.pendencie) return false;
      if (!this.pendencie.pendencyUserPermissions) return false;
      if (!this.pendencie.pendencyUserPermissions) return false;
      return this.pendencie.pendencyUserPermissions.isCommenter;
    },
    formatedDateExpiration() {
      if (this.isExpired) {
        let date = new Date(this.pendencie.dateExpiration);
        return date.toLocaleString();
      }
      return "";
    },
    formatedDatePendecie() {
      if (this.pendencie) {
        let date = new Date(this.pendencie.creationDate);
        return date.toLocaleString();
      }
      return "";
    },
    formatedDatePendecieApproval() {
      if (this.pendencie) {
        if (this.pendencie.approvalDate) {
          let date = new Date(this.pendencie.approvalDate);
          return date.toLocaleString();
        }
      }
      return "";
    },
    isApproved() {
      if (this.pendencie) {
        if (this.isExpired == false) {
          if (this.pendencie.approvalDate != null) {
            return true;
          }
        }
      }
      return false;
    },
    isDisapproved() {
      if (this.pendencie) {
        if (this.isExpired == false) {
          if (this.pendencie.disapprovalDate != null) {
            return true;
          }
        }
      }
      return false;
    },
    isExpired() {
      if (this.pendencie) {
        return this.pendencie.expired;
      }
      return false;
    },
    isOpened() {
      if (this.isApproved) return false;
      if (this.isDisapproved) return false;
      if (this.isExpired) return false;
      return true;
    },
  },
  methods: {
    show(valueId, fieldName) {
      this.checklistValueId = valueId;
      this.fieldName = fieldName;
      this.loadData();
      this.$refs.openModal.show();
    },
    ok() {
      this.$emit("approvalPendency");
    },
    async loadData() {
      this.isInApproval = false;
      this.$apiChecklist
        .get("/v1/pendencies/getByValueId/" + this.checklistValueId)
        .then((response) => {
          this.pendencie = response.data.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          this.pendencie = {};
          this.$forceUpdate();
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    approvalBegin() {
      this.isInApproval = true;
      this.isInDisapproval = false;
    },
    approvalCancel() {
      this.isInApproval = false;
      this.isInDisapproval = false;
    },
    approvalEnd() {
      this.isInApproval = false;
      this.isInDisapproval = false;
      this.$refs.openModal.hide();
      this.$emit("approvalPendency");
      //   this.loadData();
    },
    disapprovalBegin() {
      this.isInApproval = false;
      this.isInDisapproval = true;
    },
    disapprovalCancel() {
      this.isInApproval = false;
      this.isInDisapproval = false;
    },
    disapprovalEnd() {
      this.isInApproval = false;
      this.isInDisapproval = false;
      this.loadData();
    },
  },
};
</script>
